function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-accesMezzaComble");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-accesMezzaComble",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5,3.5 L26.5,3.5 M26.5,26.4230769 L26.5,3.57692308 M3.5,26.5 L26.5,26.5 M3.5,26.4230769 L3.5,3.57692308 M9.5,26 L9.5,8 M9.5,23 L20.5,23 M9.5,13 L20.5,13 M9.5,18 L20.5,18 M20.5,26 L20.5,8",
  id: "steps"
})));

const SvgIco30AccesMezzaComble = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30AccesMezzaComble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-accesMezzaComble.210462a7.svg";
export { ForwardRef as ReactComponent };